import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import admissionUtil from '../../../../../../utils/admissionUtil';

const useStyles = makeStyles(() => ({
  container: ({ bedNoFont }) => ({
    display: 'flex',
    width: '4.2rem',
    height: '4.22rem',
    minHeight: '4.22rem',
    gap: '0.357rem',
    position: 'relative',
    flex: 1,
    cursor: 'pointer',
    marginLeft: '0.357rem',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.214rem',
      height: '100%',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
      backgroundColor: bedNoFont,
    },
  }),
  patientInfo: ({ rootBg }) => ({
    paddingLeft: '0.32rem',
    backgroundColor: rootBg,
    flex: 1,
    borderRadius: '4px',
    width: '100%',
  }),
  wardBedContainer: {
    display: 'flex',
    gridGap: '0.214rem',
    justifyContent: 'flex-end',
    paddingRight: '0.714rem',
  },
  queuebarWardBedContainer: ({ bedNoFont }) => ({
    color: bedNoFont,
    fontSize: '0.857rem',
    fontWeight: 700,
    minHeight: '1.02rem',
    marginTop: '0.1rem',
  }),
  bedNo: ({ bedNoFont }) => ({
    minHeight: '1.325rem',
    color: bedNoFont,
    fontSize: '0.785rem',
    lineHeight: 1.1,
    fontWeight: 700,
  }),
  wardNo: ({ bedNoFont }) => ({
    minHeight: '1.325rem',
    color: bedNoFont,
    fontSize: '0.642rem',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'flex-end',
  }),
  caseNo: ({ bedNoFont }) => ({
    fontSize: '0.643rem',
    color: bedNoFont,
    fontWeight: 700,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
  emptyBed: ({ rootBg, bedNoFont }) => ({
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: rootBg,
    color: bedNoFont,
    borderRadius: '4px',
  }),
  emptyBedNo: ({ bedNoFont }) => ({
    fontSize: '1.285rem',
    fontWeight: 700,
    color: bedNoFont,
    lineHeight: 1,
  }),
  emptyWardNo: ({ bedNoFont }) => ({
    fontSize: '0.857rem',
    fontWeight: 700,
    color: bedNoFont,
  }),
  patientName: {
    fontSize: '0.857rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: `
      "HA_MingLiu", "NotoSans-Medium",
      serif
    `,
  },
  patientNameEn: {
    fontSize: '0.643rem',
    fontWeight: 600,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.1,
    maxHeight: '1.42rem',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
}));

export default function BedWithPatientInfo({
  style,
  styles,
  patInfo,
  caseNo,
  isQueueBar = false,
  displayWardNo,
  displayBedNo,
}) {
  const classes = useStyles(style ?? styles);
  const patientName = admissionUtil?.useGetName({
    chiName: patInfo?.chiName,
    engName: patInfo?.engName,
    loginFlag: true,
    returnFormat: 'obj',
  });

  return (
    <Box className={classes.container}>
      {patInfo ? (
        <Box className={classes.patientInfo}>
          {isQueueBar ? (
            <Box className={classes.queuebarWardBedContainer}>{`${displayBedNo}${
              displayWardNo && `,${displayWardNo}`
            }`}</Box>
          ) : (
            <Box className={classes.wardBedContainer}>
              {displayWardNo && <Box className={classes.wardNo}>{displayWardNo}</Box>}
              <Box className={classes.bedNo}>{displayBedNo}</Box>
            </Box>
          )}

          {/* <Box className={classes.caseNo} title={caseNo}>
            {caseNo}
          </Box> */}
          <Box className={classes.patientName} title={patientName?.nameZh}>
            {patientName?.nameZh}
          </Box>
          <Box className={classes.patientNameEn} title={patientName?.nameEn}>
            {patientName?.nameEn}
          </Box>
        </Box>
      ) : (
        <Box className={classes.emptyBed}>
          <Box className={classes.emptyBedNo}>{displayBedNo}</Box>
          <Box className={classes.emptyWardNo}>{displayWardNo}</Box>
        </Box>
      )}
    </Box>
  );
}
